// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.real-id-image-viewer {
  padding: 16px;
  margin: 16px 0;
}

.real-id-image-viewer__heading {
  font-size: 18px;
  font-weight: 600;
  color: #334155;
  margin: 0 0 16px;
}

.real-id-image-viewer__photo {
  margin: 20px 0;
}

.real-id-image-viewer__controls {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  margin-bottom: 8px;
}

.real-id-image-viewer__icon-btn {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: 1px solid #64748b;
  border-radius: 9999px;
  color: #64748b;
  background: #fff;
  cursor: pointer;
  box-sizing: border-box;
}

.real-id-image-viewer__icon-btn:hover {
  background: #f1f5f9;
}

.real-id-image-viewer__icon-btn--download {
  margin-right: 12px;
}

.real-id-image-viewer__frame {
  position: relative;
  display: block;
  padding: 4px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: zoom-in;
  text-decoration: none;
}

.real-id-image-viewer__frame:hover {
  background: #f1f5f9;
}

.real-id-image-viewer__img {
  display: block;
  width: 100%;
  border-radius: 4px;
}

.real-id-image-viewer__bbox {
  position: absolute;
  display: block;
  z-index: 10;
  border: 2px solid #2563eb;
}

.real-id-image-viewer__bbox--match {
  border-color: #16a34a;
}

.real-id-image-viewer__bbox--mismatch {
  border-color: #dc2626;
  background: conic-gradient(
      rgb(236 89 136 / 16%) 25%,
      rgb(214 31 31 / 10%) 0 50%,
      rgb(204 42 42 / 30%) 0 75%,
      rgb(245 57 57 / 20%) 0
    )
    0 0 / 10px 10px;
}

.real-id-image-viewer__mismatch-badge {
  position: absolute;
  right: 16px;
  top: 16px;
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  background: #fff;
  color: #0f172a;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  z-index: 10;
}

.real-id-image-viewer__mismatch-badge svg {
  width: 18px;
  height: 18px;
  color: #eab308;
  margin-right: 4px;
}

.real-id-image-viewer__sandbox-banner {
  position: relative;
  z-index: 20;
  padding: 8px;
  background: #f97316;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}

.real-id-image-viewer__caption {
  display: block;
  margin-top: 4px;
  font-size: 14px;
  color: #64748b;
}

.real-id-image-viewer__modal-body p {
  margin-bottom: 12px;
}

.real-id-image-viewer__lightbox {
  position: fixed;
  inset: 0;
  z-index: 100100;
  background: rgba(15, 23, 42, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  box-sizing: border-box;
}

.real-id-image-viewer__lightbox-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #0f172a;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.real-id-image-viewer__lightbox-controls {
  position: absolute;
  top: 16px;
  left: 16px;
  display: flex;
  gap: 6px;
}

.real-id-image-viewer__lightbox-icon-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #0f172a;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.real-id-image-viewer__lightbox-frame {
  position: relative;
  max-width: min(90vw, 1200px);
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.real-id-image-viewer__lightbox-img {
  display: block;
  max-width: 100%;
  max-height: 90vh;
  width: auto;
  height: auto;
  -o-object-fit: contain;
     object-fit: contain;
  background: #fff;
}

.real-id-image-viewer__pending-headshot {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 16px 0;
  padding: 16px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
}

.real-id-image-viewer__pending-headshot-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  color: #64748b;
  margin-top: 2px;
}

.real-id-image-viewer__pending-headshot-title {
  margin: 0;
  font-weight: 600;
  color: #0f172a;
}

.real-id-image-viewer__pending-headshot-subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #64748b;
}
`, "",{"version":3,"sources":["webpack://./src/components/checks/details/imageViewer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB;;;;;;mBAMiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB","sourcesContent":[".real-id-image-viewer {\n  padding: 16px;\n  margin: 16px 0;\n}\n\n.real-id-image-viewer__heading {\n  font-size: 18px;\n  font-weight: 600;\n  color: #334155;\n  margin: 0 0 16px;\n}\n\n.real-id-image-viewer__photo {\n  margin: 20px 0;\n}\n\n.real-id-image-viewer__controls {\n  display: flex;\n  justify-content: flex-end;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.real-id-image-viewer__icon-btn {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  border: 1px solid #64748b;\n  border-radius: 9999px;\n  color: #64748b;\n  background: #fff;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.real-id-image-viewer__icon-btn:hover {\n  background: #f1f5f9;\n}\n\n.real-id-image-viewer__icon-btn--download {\n  margin-right: 12px;\n}\n\n.real-id-image-viewer__frame {\n  position: relative;\n  display: block;\n  padding: 4px;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  cursor: zoom-in;\n  text-decoration: none;\n}\n\n.real-id-image-viewer__frame:hover {\n  background: #f1f5f9;\n}\n\n.real-id-image-viewer__img {\n  display: block;\n  width: 100%;\n  border-radius: 4px;\n}\n\n.real-id-image-viewer__bbox {\n  position: absolute;\n  display: block;\n  z-index: 10;\n  border: 2px solid #2563eb;\n}\n\n.real-id-image-viewer__bbox--match {\n  border-color: #16a34a;\n}\n\n.real-id-image-viewer__bbox--mismatch {\n  border-color: #dc2626;\n  background: conic-gradient(\n      rgb(236 89 136 / 16%) 25%,\n      rgb(214 31 31 / 10%) 0 50%,\n      rgb(204 42 42 / 30%) 0 75%,\n      rgb(245 57 57 / 20%) 0\n    )\n    0 0 / 10px 10px;\n}\n\n.real-id-image-viewer__mismatch-badge {\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 12px;\n  background: #fff;\n  color: #0f172a;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  z-index: 10;\n}\n\n.real-id-image-viewer__mismatch-badge svg {\n  width: 18px;\n  height: 18px;\n  color: #eab308;\n  margin-right: 4px;\n}\n\n.real-id-image-viewer__sandbox-banner {\n  position: relative;\n  z-index: 20;\n  padding: 8px;\n  background: #f97316;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.real-id-image-viewer__caption {\n  display: block;\n  margin-top: 4px;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.real-id-image-viewer__modal-body p {\n  margin-bottom: 12px;\n}\n\n.real-id-image-viewer__lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 100100;\n  background: rgba(15, 23, 42, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  box-sizing: border-box;\n}\n\n.real-id-image-viewer__lightbox-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.92);\n  color: #0f172a;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.real-id-image-viewer__lightbox-controls {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  display: flex;\n  gap: 6px;\n}\n\n.real-id-image-viewer__lightbox-icon-btn {\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.92);\n  color: #0f172a;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.real-id-image-viewer__lightbox-frame {\n  position: relative;\n  max-width: min(90vw, 1200px);\n  max-height: 90vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.real-id-image-viewer__lightbox-img {\n  display: block;\n  max-width: 100%;\n  max-height: 90vh;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  background: #fff;\n}\n\n.real-id-image-viewer__pending-headshot {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin: 16px 0;\n  padding: 16px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.real-id-image-viewer__pending-headshot-icon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n.real-id-image-viewer__pending-headshot-title {\n  margin: 0;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.real-id-image-viewer__pending-headshot-subtitle {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: #64748b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
